// import { SettingUserIcon } from "../../ComponentsApp/Private/Components/HomePage/PrivateHeader/PrivateHeaderStyles.styled";
// import { IconButtonBack } from "../../ComponentsApp/Private/Components/Main-info/MainInfoStyles.styled";
import {
  CloseButtonModelIcon,
  SignUpEmailUserIcon,
  SignUpUserIcon,
} from "./SignUpModelStyles.styled";

export const UserIcon = () => {
  return (
    <>
      <SignUpUserIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 5.333c1.415 0 2.771 0.562 3.771 1.562s1.562 2.357 1.562 3.771-0.562 2.771-1.562 3.771c-1 1-2.357 1.562-3.771 1.562s-2.771-0.562-3.771-1.562c-1-1-1.562-2.357-1.562-3.771s0.562-2.771 1.562-3.771c1-1 2.357-1.562 3.771-1.562zM16 18.667c5.893 0 10.667 2.387 10.667 5.333v2.667h-21.333v-2.667c0-2.947 4.773-5.333 10.667-5.333z" />
      </SignUpUserIcon>
    </>
  );
};

export const EmailUserIcon = () => {
  return (
    <>
      <SignUpEmailUserIcon
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M26.667 5.333h-21.333c-1.467 0-2.653 1.2-2.653 2.667l-0.013 16c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667v-16c0-1.467-1.2-2.667-2.667-2.667zM26.667 10.667l-10.667 6.667-10.667-6.667v-2.667l10.667 6.667 10.667-6.667v2.667z" />
      </SignUpEmailUserIcon>
    </>
  );
};

export const CloseButtonIcon = () => {
  return (
    <>
      <CloseButtonModelIcon
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.001 17.867l-6.533 6.533c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933l6.533-6.533-6.533-6.533c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367l6.533 6.533 6.533-6.533c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933l-6.533 6.533 6.533 6.533c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367l-6.533-6.533z" />
      </CloseButtonModelIcon>
    </>
  );
};

// export const SettingAccountUser = () => {
//   return (
//     <>
//       <SettingUserIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
//         <path d="M16 1.127l12.88 7.437v14.872l-12.88 7.437-12.88-7.437v-14.872l12.88-7.437zM16 4.207l-10.213 5.896v11.795l10.213 5.896 10.213-5.896v-11.795l-10.213-5.896zM16 12c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828 0.421 2.078 1.172 2.828c0.75 0.75 1.768 1.172 2.828 1.172s2.078-0.421 2.828-1.172c0.75-0.75 1.172-1.768 1.172-2.828s-0.421-2.078-1.172-2.828c-0.75-0.75-1.768-1.172-2.828-1.172zM9.334 16c0-1.768 0.702-3.464 1.953-4.714s2.946-1.953 4.714-1.953 3.464 0.702 4.714 1.953c1.25 1.25 1.953 2.946 1.953 4.714s-0.702 3.464-1.953 4.714c-1.25 1.25-2.946 1.953-4.714 1.953s-3.464-0.702-4.714-1.953c-1.25-1.25-1.953-2.946-1.953-4.714z" />
//       </SettingUserIcon>
//     </>
//   );
// };

// export const ButtonBack = () => {
//   return (
//     <>
//       <IconButtonBack viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
//         <path d="M9.227 16.666l7.252 7.252c0.13 0.13 0.198 0.283 0.204 0.459s-0.066 0.337-0.213 0.484c-0.146 0.142-0.303 0.215-0.471 0.217s-0.324-0.071-0.472-0.217l-8.107-8.107c-0.116-0.117-0.198-0.236-0.245-0.357s-0.071-0.253-0.071-0.397c0-0.144 0.024-0.276 0.071-0.397s0.129-0.24 0.245-0.356l8.107-8.108c0.125-0.124 0.276-0.191 0.455-0.2s0.343 0.058 0.489 0.2c0.147 0.147 0.22 0.305 0.22 0.475s-0.073 0.329-0.22 0.476l-7.245 7.244h15.44c0.19 0 0.349 0.064 0.476 0.191s0.191 0.286 0.191 0.476-0.063 0.349-0.191 0.476c-0.127 0.127-0.286 0.191-0.476 0.191h-15.439z"></path>
//       </IconButtonBack>
//     </>
//   );
// };
